import { request } from "../utils";
import { apis } from "../constants";

export const login = (data: Partial<LoginPayload>) => {
    return request<{ data: LoginResponse, success: boolean, msg: string }>(apis.login, { method: 'post', data })
}

export const logout = (data:
    {
        accessToken: string;
        applicationId: string
    }
) => {
    return request<ResponseData<any>>(apis.logout, { method: 'post', data })
}

export const searchUsers = (data: Partial<SearchUserParams>) => {
    return request<PagedData<UserRecord>>(apis.searchUsers, {
        method: 'post', data
    })
}

export const searchUsersGlobal = (data: Partial<{
    pageNum: number, pageSize: number, queryName: string
}>) => {
    return request<PagedData<UserRecord>>(apis.searchUsersGlobal, {
        method: 'post', data
    })
}

export const deleteUser = (userId: string | number) => {
    return request(apis.deleteUser, {
        method: 'delete', params: { userId }
    })
}

export const resetPassword = (userId: string | number, password: string) => {
    return request(apis.resetPassword, {
        method: 'put', params: { userId }, data: { password }
    })
}

export const updateUser = (userId: string | number, data: Partial<UserRecord>) => {
    return request(apis.updateUser, {
        params: { userId }, data, method: 'put'
    })
}
export const createUser = (data: Partial<UserRecord>) => {
    return request(apis.addUser, {
        data, method: 'post'
    })
}

export const getRoleList = () => {
    return request<ResponseData<RoleRecord[]>>(apis.roleList)
}

export const getUser = (userId: string) => {
    return request<UserRecord>(apis.getUser, { params: { userId } })
}

export const updatePassword = (data: {
    "newPassword": string,
    "oldPassword": string,
    "repeatPassword": string,
    "userId": number | string
}) => {
    return request(apis.updatePassword, {
        data, method: 'post'
    })
}